import { useCallback, useEffect, useState } from "react";
import Table from "../../common/Table";
import { LuPencilLine } from "react-icons/lu";
import { AiOutlineDelete } from "react-icons/ai";
import { toast } from "react-toastify";
import ConfirmationPage from "../../common/ConfirmationPage";
import { deleteCourse, getCourses } from "../../redux/services/courseSlice";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../constant";
import { useDispatch, useSelector } from "react-redux";

const Courses = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getCourseData = useSelector((state) => state?.course?.courseData);

  const [page, setPage] = useState(0);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");

  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];

  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);

  const getAllCourses = useCallback(async () => {
    try {
      await dispatch(getCourses({ page: page + 1, limit: pageLimit, searchData }));
    } catch (error) { }
  }, [dispatch, page, pageLimit, searchData]);

  useEffect(() => {
    getAllCourses();
  }, [getAllCourses]);

  const deleteCourseData = async () => {
    try {
      const response = await dispatch(deleteCourse(itemToDelete));
      toast.success(response?.payload?.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
      setConfirm(false);
      getAllCourses();
    } catch (error) { }
  };

  const columns = [
    {
      header: "S/N",
      key: "index",
      render: (_, __, index) => page * pageLimit + index + 1,
    },
    { header: "Title", key: "title" },
    {
      header: "Description", key: "description",
      render: (value) =>
        value ? (
          <div className="truncate max-w-[400px]" dangerouslySetInnerHTML={{ __html: value }} ></div>
        ) : (
          "—"
        ),
    },
    {
      header: "Image",
      key: "image",
      render: (value) =>
        value ? (
          <button className="max-w-16 max-h-16 rounded-xl overflow-hidden border border-border">
            <img src={value} alt="" className="w-full h-full object-cover" />
          </button>
        ) : (
          "—"
        ),
    },
    { header: "priority", key: "priority" },
    { header: "Language", key: "language" },
    { header: "Price (₹)", key: "price" },
    { header: "Discount Price (₹)", key: "discountPrice" },
    { header: "Paying Price (₹)", key: "payingPrice" },
    {
      header: "Course Money Back",
      key: "courseMoneyBack",
      render: (value) => (value ? "Yes" : "No"),
    },
    { header: "Course Upgrade Price (₹)", key: "courseUpgradePrice" },
    { header: "Total Lectures", key: "totalLecture" },
    { header: "Total Tests", key: "totalTest" },
    { header: "Price Instruction", key: "priceInStruction" },
    {
      header: "Syllabus Level",
      key: "syllabus",
      render: (value) => value?.subjectLevel || "—",
    },
    {
      header: "Full Syllabus",
      key: "syllabus",
      render: (value) => (value?.fullSyllabus === "yes" ? "Yes" : "No"),
    },
    {
      header: "PDF",
      key: "pdf",
      render: (pdf) =>
        pdf ? (
          <a href={pdf} target="_blank" rel="noreferrer" className="text-primary underline">
            View
          </a>
        ) : (
          "—"
        ),
    },
  ];

  const actions = [
    {
      icon: <LuPencilLine className="w-5 h-5" />,
      onClick: (row) => {
        navigate(`${ROUTES.COURSES.EDIT}?courseId=${row._id}`, {
          state: { row },
        });
      },
    },
    {
      icon: <AiOutlineDelete className="w-6 h-6" />,
      onClick: (row) => {
        setItemToDelete(row._id);
        setConfirm(true);
      },
    },
  ];

  return (
    <>
      <Table title="Course" buttonTitle="Add Course" showSearchbar={true} searchTerm={searchTerm} setSearchTerm={setSearchTerm} setSearchData={setSearchData} onAddClick={() => navigate(ROUTES.COURSES.ADD)} columns={columns} data={getCourseData?.course_data || []} actions={actions} pageCount={getCourseData?.state?.page_limit} onPageChange={(selectedItem) => setPage(selectedItem.selected)} pageLimitOptions={limitOptions} selectedPageLimit={pageLimit} onPageLimitChange={setPageLimit} />
      {confirm && <ConfirmationPage topicName="Course" confirm={confirm} onDelete={deleteCourseData} onCancel={() => setConfirm(false)} />}
    </>
  );
};

export default Courses;
